export const vehicleTypes = {
  COMPACT: 'COMPACT',
  ECONOMY: 'ECONOMY',
  MINI: 'MINI',
  STANDARD: 'STANDARD',
  INTERMEDIATE: 'INTERMEDIATE',
  INTERMEDIATE_ELITE: 'INTERMEDIATE_ELITE',
  FULL_SIZE: 'FULL_SIZE',
  LUXURY: 'LUXURY', // not verified
  PREMIUM: 'PREMIUM',
  SUV: 'SUV', // not verified
};

export const fuelPolicies = {
  FULL_TO_FULL: 'FULL_TO_FULL',
  FULL_TO_EMPTY: 'FULL_TO_EMPTY',
};

export const transmissionTypes = {
  AUTOMATIC: 'AUTOMATIC',
  MANUAL: 'MANUAL', // not verified
};

export const vehicleTypeGroups = [
  [
    vehicleTypes.ECONOMY,
    vehicleTypes.COMPACT,
    vehicleTypes.MINI,
  ],
  [
    vehicleTypes.STANDARD,
    vehicleTypes.INTERMEDIATE,
    vehicleTypes.INTERMEDIATE_ELITE,
  ],
  [
    vehicleTypes.FULL_SIZE,
    vehicleTypes.LUXURY,
    vehicleTypes.PREMIUM,
    vehicleTypes.SUV,
  ],
];



/** WEBPACK FOOTER **
 ** ./src/constants/carHire.js
 **/